import firebase from 'firebase';
import { useAtom } from 'jotai';
import { auth } from './firebase';
import { userRecordAtom } from '../state/atoms';
import { firebaseErrorCodes } from '../utils/constants';

function useAuthService() {
  const [, setUserRecord] = useAtom(userRecordAtom);

  const createUserWithEmailAndPassword = (email, password) =>
    auth()
      .createUserWithEmailAndPassword(email, password)
      .catch((err) => {
        switch (err.code) {
          case firebaseErrorCodes.EMAIL_IN_USER:
            break;
          default:
            break;
        }
      });

  const signIn = (email, password) =>
    firebase
      .auth()
      .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
      // eslint-disable-next-line arrow-body-style
      .then(() => {
        return auth()
          .signInWithEmailAndPassword(email, password)
          .then((res) => res);
      });

  const resetPassword = (email) =>
    auth()
      .sendPasswordResetEmail(email)
      .then((res) => res);

  function signOut() {
    setUserRecord(null);
    return auth().signOut();
  }

  return { createUserWithEmailAndPassword, signIn, resetPassword, signOut };
}

export default useAuthService;
